"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMinPrice = void 0;
var _utils = require("@cian/utils");
const formatMinPrice = minPrice => {
  return minPrice > 0 ? `от ${(0, _utils.numberToPrettyString)(minPrice)} ₽` : '';
};
exports.formatMinPrice = formatMinPrice;